import React, { useState } from 'react';

// Placeholder for your image - replace with actual import
import CarImage from "../Assets/CONVEINCE.jpg";

const CarFeatureCarousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const slides = [
    {
      id: 1,
      title: "EXPLORE CONVENIENCE",
      description: "Designed aerodynamically to provide excellent performance and smooth drives every time you embark on a journey.",
      image: CarImage
    }
    // Add more slides as needed
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <div className="w-full bg-white py-12 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-12">
          {/* Left side - Text content */}
          <div className="lg:w-1/2 space-y-8">
            {/* Title */}
            <h1 className="text-4xl md:text-3xl font-bold text-gray-900 uppercase tracking-wider">
              EXPLORE CONVENIENCE
            </h1>
            
            {/* Description */}
            <p className="text-lg text-gray-600 leading-relaxed max-w-xl">
              Designed aerodynamically to provide excellent performance and smooth drives every time you embark on a journey.Planning a family trip? Whether it’s a wedding, vacation, airport transfer, or temple visit, the Force Urbania is designed to make every journey comfortable, safe, and memorable for your entire family.
            </p>

            {/* Navigation buttons - Simple */}
            {/* <div className="flex items-center gap-6 pt-4">
              <button
                onClick={prevSlide}
                className="text-gray-700 hover:text-gray-900 font-medium text-lg transition-colors"
              >
                ← PREV
              </button>
              
              <div className="h-0.5 w-8 bg-gray-300"></div>
              
              <button
                onClick={nextSlide}
                className="text-blue-600 hover:text-blue-700 font-medium text-lg transition-colors"
              >
                NEXT →
              </button>
            </div> */}
          </div>

          {/* Right side - Image */}
          <div className="lg:w-1/2">
            <div className="w-full h-72 md:h-96 rounded-lg overflow-hidden shadow-lg">
              <img
                src={CarImage}
                alt="Car"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CarFeatureCarousel;